import { render } from "./AccountModalDeleteAccount.vue?vue&type=template&id=a7bfe35a&scoped=true"
import script from "./AccountModalDeleteAccount.vue?vue&type=script&lang=js"
export * from "./AccountModalDeleteAccount.vue?vue&type=script&lang=js"

import "./AccountModalDeleteAccount.vue?vue&type=style&index=0&id=a7bfe35a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a7bfe35a"

export default script